import { DEFAULT_TEXT_COLOR } from 'JS/config/defaults';

import { defaultFontLabel, defaultFontValue } from '../shared/resources/scribedefaults';

import ScribeElementModel from './ScribeElementModel';

class ScribeTextElementModel extends ScribeElementModel {
  constructor(data) {
    super(data, 'Text');

    this.font = data && data.font ? data.font : { label: defaultFontLabel, value: defaultFontValue };

    this.svg = data && data.svg;

    if (data && data.id) {
      this.text = data.text;
      this.align = data.align || 'left';
      this.fill = data.fill || data.color || DEFAULT_TEXT_COLOR;
      this.fontSize = data.fontSize || 120;
      this.fontWeight = data.fontWeight || 'normal';
      this.fontStyle = data.fontStyle || 'normal';
      this.opacity = data.opacity;
    } else {
      this.align = 'left';
      this.fill = DEFAULT_TEXT_COLOR;
      this.fontSize = 120;
      this.fontWeight = 'normal';
      this.fontStyle = 'normal';
      this.opacity = 1;
    }
  }
}

export default ScribeTextElementModel;
